import { BannerStatic } from '../../components'
import * as actions from './slice'

const getTenant = {
  eventName: 'tenantGetAdmin',
  onSuccess: [{ action: actions.getTenant, redux: true }
  ]
}

const getTenantApiIntegrationKeys = {
  eventName: 'integrationGetTenantApiKeys',
  onSuccess: [
    { action: actions.setApiIntegration, redux: true }
  ]
}

const getHelixMigrationConfig = {
  eventName: 'getHelixMigrationConfig',
  onSuccess: [
    { action: actions.setHelixMigrationConfig, redux: true }
  ]
}

const checkSharedLinkProgress = {
  eventName: 'getHelixMigrationConfig',
  onSuccess: [
    { action: actions.setHelixMigrationConfig, redux: true }
  ]
}

const updateHelixMigrationConfig = {
  eventName: 'updateTenantHelixSubscriptionUrl',
  onSuccess: [
    { action: actions.setHelixMigrationConfig, redux: true },
    () => BannerStatic.show({ label: 'Helix Migration settings have been successfully updated' })
  ],
  onError: () => BannerStatic.show({ label: 'Failed to update Helix Migration settings', isError: true })
}

const toggleHelixConfigEnabled = {
  eventName: 'toggleHelixConfigEnabled',
  onSuccess: [
    { action: actions.toggleHelixConfigEnabled, redux: true },
    () => BannerStatic.show({ label: 'Helix Migration settings have been successfully updated' })
  ],
  onError: () => BannerStatic.show({ label: 'Failed to update Helix Migration settings', isError: true })
}

const generateTenantApiKeys = {
  eventName: 'integrationGenerateTenantApiKeys',
  onSuccess: [
    { action: actions.setApiIntegration, redux: true },
    () => BannerStatic.show({ label: 'API Integration keys have been successfully generated' })
  ],
  onError: () => BannerStatic.show({ label: 'Failed to generate API Integration keys', isError: true })
}

const removeTenantApiKeys = {
  eventName: 'integrationRemoveTenantApiKeys',
  onSuccess: [
    { action: actions.setApiIntegration, redux: true },
    () => BannerStatic.show({ label: 'API Integration keys have been successfully removed' })
  ],
  onError: () => BannerStatic.show({ label: 'Failed to remove API Integration keys', isError: true })
}

export {
  getTenant,
  getTenantApiIntegrationKeys,
  generateTenantApiKeys,
  removeTenantApiKeys,
  getHelixMigrationConfig,
  updateHelixMigrationConfig,
  toggleHelixConfigEnabled,
  checkSharedLinkProgress
}
